import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, timer } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';

import { WhatsAppService } from './whatsapp.service';
import { ConversationVM } from '../models/vm/conversation-vm';


@Injectable({
  providedIn: 'root',
})
export class ConversationMessageService {
  private conversations: ConversationVM[] = [];

  private readonly _conversations = new BehaviorSubject<any[]>([]);

  conversations$ = this._conversations.asObservable();

  constructor(private whatsAppService: WhatsAppService) {}

  startConversationTimer(): Observable<any> {
    return timer(0, 5000).pipe(
      switchMap(() => this.whatsAppService.getConversations({ pageNumber: 1, pageSize: 15 })),
      map((conversations) =>
        (conversations ?? []).map((c) => ConversationVM.toVM(c))
      ),
      tap((conversations) => {
        if (this.conversations.length <= 0) {
          this.conversations = conversations;
          this._conversations.next(this.conversations);
        } else {
          const unreadConversations = (conversations || []).filter(
            (c) => c.unreadMessageCount > 0
          );
          if (unreadConversations.length) {
            const uniqueConversations = this.conversations.filter((c) =>
              unreadConversations.some((uc) => c.id !== uc.id)
            );
            this.conversations = [...unreadConversations, ...uniqueConversations];
            this._conversations.next(this.conversations);
          }
        }
      })
    );
  }

  resetUnreadMessageCount(index: number): void {
    if (
      this.conversations[index] &&
      this.conversations[index].unreadMessageCount > 0
    ) {
      this.conversations[index].unreadMessageCount = 0;
      this._conversations.next(this.conversations);
    }
  }
}
